import React from 'react'
import PropTypes from 'prop-types'
import { uuid } from '../../../../helpers';

export default class MagazineComponent extends React.Component {

    state = {
        currentMagazine: null
    }

    onMagazineClick = (url) => {
        this.setState({ currentMagazine: url })
    }	
    
    handleClick (url) {

        this.onMagazineClick(url)

        const { magazineTop } = this.props;

        setTimeout(function() {
            
            magazineTop();
        }, 500)

        
    }
	
    render() {
        const {
            magazines_array,
        } = this.props;
        const {
            currentMagazine
        } = this.state;

        return (
            <section className="magazine-component">
                <div className="container-fluid">
                    <div className="magazine__row row">
                        <ul className="magazine-list col-12">
                            {
                                magazines_array && magazines_array.map((magazine) => (
                                    <li className="magazine-list__item" key={uuid()} onClick={() => {this.handleClick(magazine.url)}}>
                                        <img src={magazine.small_img} alt="Magazine In Touch" className="img-fluid" />
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                <div id="current-magazine"></div>
                </div>
                { 
                    currentMagazine && (
                        <div style={{ height: '90vh' }}>
                            <iframe
                                frameBorder={0}
                                width="100%"
                                height="100%"
                                src={currentMagazine}
                                scrolling="no"
                                type="text/html"
                                marginWidth={0}
                                marginHeight={0}
                                allowFullScreen
                            />
                        </div>
                    )
                }
            </section>
        );
    }
}


MagazineComponent.propTypes = {
    magazines_array: PropTypes.array
}


// WEBPACK FOOTER //
// src/client/components/site/features/magazine/MagazineComponent.js